import { render, staticRenderFns } from "./formsManager.vue?vue&type=template&id=52c5c8d3&"
import script from "./formsManager.vue?vue&type=script&lang=js&"
export * from "./formsManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports